export default __webpack_public_path__ + "static/media/Lato-ThinItalic.c47d267d.ttf";